import { createContext } from 'react'
import { FeatureFlags } from './types'

export const FeatureFlagsContext = createContext<FeatureFlags | null>(null)
